import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth0();
  const location = useLocation();
  
  // Check if we're in the callback URL with code and state
  const query = new URLSearchParams(location.search);
  const isAuthCallback = query.get('code') && query.get('state');
  
  // If we're in the callback URL, show loading
  if (isAuthCallback) {
    return <div className="loading-container">Hitelesítés feldolgozása...</div>;
  }

  // Show loading while checking authentication
  if (isLoading) {
    return <div className="loading-container">Ellenőrizzük a bejelentkezési adatokat...</div>;
  }

  // If not authenticated, redirect to home page
  if (!isAuthenticated) {
    console.log("User not authenticated, redirecting to home");
    return <Navigate to="/" replace />;
  }

  // If authenticated, show the protected content
  return children;
};

export default ProtectedRoute; 